import React from 'react'
import { t, Trans } from '@lingui/macro'
import businessLogos from '../../../assets/business-logos'
import LocalisedImage from '../common/LocalisedImage'
import './TrustedBy.scss'

const trustedByBusinessesIcons = Object.values(businessLogos)
const TRUSTED_BY_TITLE = t`Trusted by governments and businesses`

const TrustedBy = () => (
  <div className="trusted-by__container">
    <div className="trusted-by__container__title">
      <Trans id={TRUSTED_BY_TITLE} />
    </div>
    <div className="trusted-by__container__icons">
      {trustedByBusinessesIcons && trustedByBusinessesIcons.map(icon => (
        <LocalisedImage className="trusted-by__container__icon" src={icon} alt={t`Business Logo`} key={icon} />
      ))}
    </div>
  </div>
)

export default TrustedBy
